export const layoutValues = {
  CONTAINER_WIDTH: '94rem',
  LESSON_WIDTH: '71.75rem',
  TOP_BAR_SESSION_HEIGHT: '4rem',
  TOP_BAR_BASE_HEIGHT: '4rem',
  TOP_BAR_BASE_MOBILE_HEIGHT: '4rem',
  TOP_BAR_SESSION_MOBILE_HEIGHT: '4.25rem',
  TOP_BAR: '4rem',
} as const
